import { render, staticRenderFns } from "./supported-program-list.vue?vue&type=template&id=2343d2bc"
var script = {}
import style0 from "./supported-program-list.vue?vue&type=style&index=0&id=2343d2bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports